import { Component } from '@angular/core';

import { CallService } from '../core';

import { TranslationKeyMap } from './hud.component.i18n';

@Component({
    selector: 'cmps-localcall-hud',
    templateUrl: './hud.component.html',
    host: {
        class: 'cmps-localcall-hud',
    },
})
export class HudComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    constructor(/** @private */ readonly _service: CallService) {}
}
